import React, { useEffect, useRef, useState } from "react";

const VIDEO_DIR = `${process.env.PUBLIC_URL || ""}/video`;
const POSTER = `${VIDEO_DIR}/crowd-poster.jpg`;

// A still image is kinder than a video for visitors who asked for less
// motion or less data
export const prefersStillImage = () =>
  (typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches) ||
  Boolean(navigator.connection && navigator.connection.saveData);

// The dimmed, blurred crowd behind the hero. Decorative only: the text in
// front of it carries the meaning.
const VideoBackground = () => {
  const [showVideo, setShowVideo] = useState(() => !prefersStillImage());
  const videoRef = useRef(null);

  // A browser that refuses to autoplay (iOS Low Power Mode, strict
  // settings) would leave a paused video with a play button showing
  // through the overlay; the still image looks finished instead
  useEffect(() => {
    const video = videoRef.current;
    if (!video || typeof video.play !== "function") return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === "function") {
      attempt.catch(() => setShowVideo(false));
    }
  }, []);

  const mediaClassName = "h-full w-full object-cover scale-105 blur-[2px]";

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      {showVideo ? (
        <video
          ref={videoRef}
          className={mediaClassName}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={POSTER}
          onError={() => setShowVideo(false)}
          data-testid="hero-video"
        >
          <source src={`${VIDEO_DIR}/crowd.webm`} type="video/webm" />
          <source src={`${VIDEO_DIR}/crowd.mp4`} type="video/mp4" />
        </video>
      ) : (
        <img className={mediaClassName} src={POSTER} alt="" data-testid="hero-still" />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#232323]" />
    </div>
  );
};

export default VideoBackground;
